// import { memo, useEffect, useRef } from "react";
// import audio from "../../assets/audio/warning.wav";
// import { Accident } from "../../atoms/accident";

// type Prop = {
//   accident: Accident;
// };
// /**
//  * 전복사고 발생시 경고음 재생
//  *
//  * 사고가 확인되면 자동으로 종료함
//  *
//  * 화면에 출력되지 않는 컴포넌트임
//  */
// export const AccidentAudio = memo(({ accident }: Prop) => {
//   const audioRef = useRef<HTMLAudioElement>(null);

//   useEffect(() => {
//     if (!audioRef || !audioRef.current) return;
//     const audio: HTMLAudioElement = audioRef.current;
//     if (accident !== null) {
//       audio.loop = true;
//       audio.play();
//     } else {
//       audio.loop = false;
//       audio.pause();
//     }
//     return () => {
//       audio.pause();
//       audio.currentTime = 0;
//     };
//   }, [accident]);

//   return (
//     <audio
//       style={{ display: "none" }}
//       ref={audioRef}
//       src={audio}
//       controls
//       loop
//     ></audio>
//   );
// });
import { memo, useEffect, useRef } from "react";
import audioSrc from "../../assets/audio/warning.wav";
import { Accident } from "../../atoms/accident";

type Prop = {
  accident: Accident | null;
};

/**
 * 전복사고 발생 시 경고음 재생
 * 사고가 확인되면 자동 종료
 * 화면에 출력되지 않는 컴포넌트
 */
export const AccidentAudio = memo(({ accident }: Prop) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    if (!audioRef.current) {
      audioRef.current = new Audio(audioSrc); // 오디오 인스턴스 생성
      audioRef.current.loop = true; // 루프 설정
    }

    const audio = audioRef.current;

    if (accident) {
      // 사용자의 상호작용이 없을 경우 play() 실패 가능 → catch로 감싸기
      audio
        .play()
        .catch((error) => console.error("Audio play failed:", error));
    } else {
      audio.pause();
      audio.currentTime = 0;
    }

    return () => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
    };
  }, [accident]);

  return null; // 화면에 출력하지 않음
});
